const home = {
  hero_title_line1: '洞洞杂货铺',
  hero_title_line2: '漫画全集',
  hero_title_line3: '下拉式免费阅读',
  hero_subtitle: '无删减内容 + 流畅加载，全章节覆盖，轻松追完整个故事',
  hero_cta: '开始阅读',
  section_latest_title: '最新',
  section_latest_highlight: '更新',
  section_latest_subtitle: '实时追踪你喜爱的漫画最新章节',
  section_latest_tag: '实时更新',
  section_hot_title: '热门漫画',
  section_hot_tag: '大家都在看',
  section_editor_title: '编辑精选',
  section_editor_quote: '专业漫画编辑团队为你精选优质内容',
  section_editor_read: '去阅读',
  section_cta_title_line1: '加入布丁漫画网',
  section_cta_title_line2: '开启你的漫画之旅',
  section_cta_desc: '海量正版漫画、无删减完整内容、流畅下拉式阅读体验。注册即享专属书签和阅读记录同步。',
  section_cta_btn: '免费注册',
  comic_chapters: '话',
  comic_views: '阅读',
  comic_rating: '分',
  breadcrumb_home: '首页',
};

export default home;